var map = {
	"./help/help.module": [
		"./src/app/pages/help/help.module.ts",
		"help-help-module"
	],
	"./legally/legal.module": [
		"./src/app/pages/legally/legal.module.ts",
		"legally-legal-module"
	],
	"./projects/projects.module": [
		"./src/app/pages/projects/projects.module.ts",
		"projects-projects-module"
	],
	"./users/users.module": [
		"./src/app/pages/users/users.module.ts",
		"users-users-module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"app-pages-pages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;